export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10047.6cc62e01.jpg";